import axios from "../../utils/axios";
import { API_SUFFIX } from "../../config/app";

// 获取维修原因列表
export function apiWhylist(query) {
    return axios({
        url: "/admin/index/whylist" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 查看维修原因
export function apiWhyupdate(query) {
    return axios({
        url: "/admin/index/whyupdate" + API_SUFFIX,
        method: "get",
        params: query
    });
}

// 编辑维修原因
export function apiWhyupdateSubmit(data, method = "post") {
    return axios({
        url: "/admin/index/whyupdate" + API_SUFFIX,
        method: method,
        data: data
    });
}

// 新增维修原因
export function apiAddsWhyadd(data, method = "post") {
    return axios({
        url: "/admin/index/whyadd" + API_SUFFIX,
        method: method,
        data: data
    });
}
// 删除维修原因
export function apiWhydelete(data, method = "post") {
    return axios({
        url: "/admin/index/whydelete" + API_SUFFIX,
        method: method,
        data: data
    });
}